import * as Parse from 'parse';
import { ModelDecorator } from '../decorators';

export default class MetaImage extends Parse.Object {

    @ModelDecorator.Variable
    public fb: Parse.File;
    
    @ModelDecorator.Variable
    public vk: Parse.File;

    @ModelDecorator.Variable
    public twitter: Parse.File;

    constructor(){
        super('MetaImage')
    }
}

Parse.Object.registerSubclass('MetaImage', MetaImage);


// WEBPACK FOOTER //
// ./src/models/MetaImage.ts